import { render } from "./ViewProducts.vue?vue&type=template&id=1acf9151&scoped=true"
import script from "./ViewProducts.vue?vue&type=script&lang=js"
export * from "./ViewProducts.vue?vue&type=script&lang=js"

import "./ViewProducts.vue?vue&type=style&index=0&id=1acf9151&scoped=true&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acf9151"]])

export default __exports__